export default {
  meta: {
    title: '数据字典'
  }
};
